import { RootState } from 'store/rootReducer'

export const isAuthorizationInited = (state: RootState) => state.user.isInited
